export default __webpack_public_path__ + "df37331960861361bcf5e011a00bc15f.png";